import { BLOQUES_DEL_MOTOR, bloqueSchema, idDeLaReferencia, respuestaEnBloquesSchema } from './spec.js';
/** Las referencias que lleva un bloque, sea cual sea el prop donde vivan. */
export function referenciasDe(bloque) {
    switch (bloque.tipo) {
        case 'NoMedido':
            return bloque.alternativa;
        case 'FraseCopiable':
            return bloque.citas;
        case 'LadoALado':
            return bloque.tarjetas.map(t => t.afirmacion);
        case 'Grafico':
            return bloque.puntos.flatMap(p => (p.hechoX ? [p.hecho, p.hechoX] : [p.hecho]));
        default:
            return [];
    }
}
export function validarEstructura(crudo, opciones) {
    const gramatical = respuestaEnBloquesSchema.safeParse(crudo);
    if (!gramatical.success) {
        return {
            valida: false,
            motivos: gramatical.error.issues.map(i => ({ tipo: 'gramatica', detalle: `${i.path.join('.')}: ${i.message}` })),
        };
    }
    const motivos = [];
    const delMotor = new Set(BLOQUES_DEL_MOTOR);
    for (const bloque of gramatical.data.bloques) {
        if (opciones.delModelo && delMotor.has(bloque.tipo)) {
            motivos.push({ tipo: 'bloque_del_motor', bloque: bloque.tipo });
        }
        if (opciones.delModelo && bloque.tipo === 'FraseCopiable' && /\[\d+\]/u.test(bloque.texto)) {
            motivos.push({ tipo: 'marca_en_frase_copiable', detalle: 'la FraseCopiable no lleva marcas [n] en el texto: su fuente va solo en `citas`' });
        }
        // El título y las etiquetas de un gráfico no llevan `[n]`: sus fuentes son los propios puntos.
        if (opciones.delModelo &&
            bloque.tipo === 'Grafico' &&
            [bloque.titulo, ...bloque.puntos.flatMap(p => [p.etiqueta, p.serie ?? ''])].some(t => /\[\d+\]/u.test(t))) {
            motivos.push({ tipo: 'marca_en_grafico', detalle: 'el título y las etiquetas del Grafico no llevan marcas [n]: cada punto cita su hecho' });
        }
        for (const referencia of referenciasDe(bloque)) {
            if (!opciones.hechosDisponibles.has(idDeLaReferencia(referencia))) {
                motivos.push({ tipo: 'referencia_inventada', referencia });
            }
        }
    }
    // En una respuesta ya montada, una Nota del motor sí es algo que enseñar: «esto queda fuera de los
    // eventos» o «falta una cifra» son la respuesta entera. Sin esto, la web pintaba «no se ha podido
    // comprobar» en lugar de la nota (visto en e2e el 2026-09-22).
    // Un `Grafico` solo no es una respuesta: es un complemento del texto, y quitado el texto no queda nada que enseñar.
    // Un `ListaEstudios` (CATALOGO-EN-CONSULTA) también es la respuesta entera a «¿qué estudios tenéis?».
    const conTexto = gramatical.data.bloques.filter(b => b.tipo !== 'Grafico' && (!delMotor.has(b.tipo) || (!opciones.delModelo && (b.tipo === 'Nota' || b.tipo === 'ListaEstudios'))));
    if (conTexto.length === 0)
        motivos.push({ tipo: 'sin_contenido' });
    if (motivos.length > 0)
        return { valida: false, motivos };
    return { valida: true, respuesta: gramatical.data };
}
/** Un bloque suelto, para cuando hace falta validar de uno en uno. */
export function validarBloque(crudo) {
    return bloqueSchema.safeParse(crudo).success;
}
//# sourceMappingURL=ValidadorEstructural.js.map